module.exports = __webpack_public_path__ + "static/media/leverageKnowledge.8fdc75ad.png";